import { combineReducers, configureStore } from '@reduxjs/toolkit';
import appStateSlice from "./slices/appState.slice";
import blacklistCatalogSlice from "./slices/blacklist.slice";
import { comparisonReducer } from "./slices/comparison.slice";
import gptApiSlice from './slices/gpt.slice.js';
import largeDataAnalyticsSlice from "./slices/largeDataAnalytics.slice";
import portfoliosSlice from "./slices/portfolios.slice";
import prospectsSlice from "./slices/prospects.slice";
import publicSlice from "./slices/public.slice";
import reportsSlice from "./slices/reports.slice";
import superuserSlice from "./slices/superUser.slice";
import timeseriesSlice from "./slices/timeseries.slice";
import timeseriesModelsSlice from "./slices/timeseriesModels.slice";
import tickerSearchListSlice from './slices/tickerSearch.slice.js';
import tickersSlice from "./slices/tickers.slice";
import userSlice from "./slices/user.slice";


const reducer = combineReducers({
  appStates: appStateSlice,
  blacklist: blacklistCatalogSlice, // Include the blacklist reducer here
  comparison: comparisonReducer,
  gptApi: gptApiSlice,
  largeDataAnalytics: largeDataAnalyticsSlice,
  public: publicSlice,
  prospects: prospectsSlice,
  portfolios: portfoliosSlice,
  reports: reportsSlice,
  superuser: superuserSlice,
  tickers: tickersSlice,
  tickerSearchList: tickerSearchListSlice.reducer,
  timeSeries: timeseriesSlice,
  timeSeriesModels: timeseriesModelsSlice,
  user: userSlice,

});


const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({}),
  devTools: process.env.NODE_ENV === 'development',
});

export default store;
